var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLegalPracticePurple = function SvgLegalPracticePurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.108a1.8 1.8 0 0 0 .272-2.768L10.862.93a1.8 1.8 0 0 0-2.733.221l-.567.787 5.68 5.679.759-.509Zm-1.775 1.19L6.85 2.926 5.265 5.129a.6.6 0 0 1-.136.136L2.925 6.852l5.374 5.374 1.508-2.254c.043-.065.1-.12.164-.164l2.254-1.51Zm-4.608 4.944-5.678-5.68-.786.568a1.8 1.8 0 0 0-.221 2.734l3.408 3.408a1.8 1.8 0 0 0 2.768-.27l.51-.76h-.001Zm4.558-3.465 6.928 6.931a1.694 1.694 0 1 1-2.396 2.395l-6.93-6.929.961-1.435 1.435-.961.002-.001ZM7.6 17.8a.6.6 0 0 0-.6-.6H3.4a.6.6 0 1 0 0 1.2H1a.6.6 0 1 0 0 1.2h8.4a.6.6 0 1 0 0-1.2H7a.6.6 0 0 0 .6-.6Z",
    fill: "#7160C5"
  })));
};

export default SvgLegalPracticePurple;